import React from 'react';

const Title = (props) => {
    return (
        <div>
            <h1 className={` ${props.className} hind toBold  no-margin no-padding toUpper title`} style={{ lineHeight: 1 }}>{props.text} {props.sub && <span className="font-14">{props.sub}</span>}</h1>
            <section style={{ width: 61, borderBottom: '4px solid #f44336', margin: 0, padding: 0 }} />
        </div>
    );
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/partials/title.js